export default "__VITE_ASSET__DHM1G$9q__"